import { Client, Invite, Theme } from "../../../../types/global"

export default (header: string, theme: Theme, client: Client, invite?: Invite) => {
    return `${header.replaceAll("{{client}}", client.name).replaceAll("{{agency}}", theme.displayName || invite?.agency.name || "")}`
}